import React, { FC } from "react";
import ButtonComponent from "../../buttons/ButtonComponent";
import { IDeviceSecretStatus } from "../../../models/IUser";

interface PopupModuleDeviceSecretProps {
  /** Видит и меняет секрет только root — то же правило, что на сервере. */
  isRoot: boolean;
  status: IDeviceSecretStatus | null;
  isLoading: boolean;
  /** Открытое значение свежей выдачи; показывается один раз, потом скрывается. */
  issuedSecret: string | null;
  onIssue: () => void;
  onRevoke: () => void;
  onHideIssued: () => void;
}

/** Дата выдачи в читаемом виде; null — журнала выдачи нет (секрет заведён скриптом). */
function formatIssuedAt(issuedAt: string | null): string | null {
  if (!issuedAt) return null;
  const date = new Date(issuedAt);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleString("ru-RU");
}

/**
 * DEV-78 (ПРВ-06, ПРВ-05): блок секрета изделия в карточке.
 *
 * Для не-root не отрисовывается вовсе: сервер такому вошедшему и не отдаёт ни
 * признака выдачи, ни значения (403), поэтому показывать «пусто» нечего.
 * Значение показывается один раз — сразу после выдачи, и скрывается кнопкой или
 * закрытием карточки; обратно его не отдаёт ни один маршрут.
 */
export const PopupModuleDeviceSecret: FC<PopupModuleDeviceSecretProps> = ({
  isRoot,
  status,
  isLoading,
  issuedSecret,
  onIssue,
  onRevoke,
  onHideIssued,
}) => {
  if (!isRoot) return null;

  const provisioned = Boolean(status?.provisioned);
  const issuedAt = formatIssuedAt(status?.issuedAt ?? null);
  const issuedBy = status?.issuedBy ?? null;

  return (
    <div className="popup_module_secret">
      <div className="popup_module_secret_head">СЕКРЕТ ИЗДЕЛИЯ</div>

      {issuedSecret ? (
        <div className="popup_module_secret_value">
          <div className="popup_module_secret_hint">
            Новый секрет — запишите его в изделие. Показывается один раз, повторно
            прочитать нельзя.
          </div>
          <div className="popup_module_secret_row">
            <code className="popup_module_secret_code">{issuedSecret}</code>
            <ButtonComponent onClick={onHideIssued} title="скрыть" />
          </div>
        </div>
      ) : null}

      <div className="popup_module_secret_state">
        {provisioned ? (
          <span>
            Секрет выдан
            {issuedAt ? `: ${issuedAt}` : ""}
            {issuedBy !== null ? `, учётная запись №${issuedBy}` : ""}
          </span>
        ) : (
          <span>Секрет не выдан</span>
        )}
      </div>

      <div className="popup_module_secret_actions">
        <ButtonComponent
          onClick={onIssue}
          disabled={isLoading}
          title={provisioned ? "перевыдать секрет" : "выдать секрет"}
        />
        {provisioned ? (
          <ButtonComponent
            onClick={onRevoke}
            type="del"
            disabled={isLoading}
            title="отозвать секрет"
          />
        ) : null}
      </div>
    </div>
  );
};
